import { render, staticRenderFns } from "./AutocompleteField.vue?vue&type=template&id=5b4aa3c4&scoped=true"
import script from "./AutocompleteField.vue?vue&type=script&lang=ts"
export * from "./AutocompleteField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4aa3c4",
  null
  
)

export default component.exports